import { formatDate } from "@fullcalendar/core";
import Modal from "../../layouts/Modal";
import { IPart } from "../../models/Part";
import { useUserLookup } from "../../hooks/useUserLookup";
import { useEffect, useMemo, useState } from "react";
import formatDateTime from "../../utils/formatDateTime";

export default function VehiclePartHistory({ part, open, onClose }: { part: IPart | null, open: boolean, onClose: any }) {
  const { findUser, isLoading: userLookupLoading } = useUserLookup();

  const [pricedBy , setPricedBy]  = useState<string | undefined>(undefined);
  const [imagedBy , setImagedBy]  = useState<string | undefined>(undefined);
  const [locatedBy, setLocatedBy] = useState<string | undefined>(undefined);
  const [pickedBy , setPickedBy]  = useState<string | undefined>(undefined);
  const [packedBy , setPackedBy]  = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!part || userLookupLoading) return;

    const priced = part.pricedBy ? findUser(part.pricedBy) : null;
    setPricedBy(priced?.fullname);

    const imaged = part.imagedBy ? findUser(part.imagedBy) : null;
    setImagedBy(imaged ? imaged.fullname : undefined);

    const located = part.locatedBy ? findUser(part.locatedBy) : null;
    setLocatedBy(located ? located.fullname : undefined);

    const picked = part.pickedBy ? findUser(part.pickedBy) : null;
    setPickedBy(picked ? picked.fullname : undefined);

    const packed = part.shippedBy ? findUser(part.shippedBy) : null;
    setPackedBy(packed ? packed.fullname : undefined);

  }, [part, userLookupLoading])

  if (part == null) return null;
 
  return (
    <Modal open={open} setOpen={onClose} width="max-w-sm xl:max-w-2xl ">
      <h2 className="text-xl font-semibold mb-4">Part History</h2>

      <hr className="mb-6" />

      <div className="grid sm:grid-cols-2 xl:grid-cols-4">
        <div className="p-2 bg-gray-50">
          <div className="text-gray-500">Date Added:</div>
          <div>{formatDateTime(part.created)}</div>
        </div>

        <div className="p-2 bg-gray-50">
          <div className="text-gray-500">Date Updated:</div>
          <div>{part.updated ? formatDateTime(part.updated) : "N/A"}</div>
        </div>
        {/* ---------------------------------------------------------- */}
        {/* ---------------------------------------------------------- */}
        <div className="p-2 bg-blue-50">
          <div className="text-gray-500">Priced By:</div>
          <div>{pricedBy}</div>
        </div>

        <div className="p-2 bg-blue-50">
          <div className="text-gray-500">Priced On:</div>
          <div>{part.pricedOn ? formatDateTime(part.pricedOn) : "N/A"}</div>
        </div>
        {/* ---------------------------------------------------------- */}
        {/* ---------------------------------------------------------- */}
        <div className="p-2 bg-green-50">
          <div className="text-gray-500">Imaged By:</div>
          <div>{imagedBy}</div>
        </div>

        <div className="p-2 bg-green-50">
          <div className="text-gray-500">Imaged On:</div>
          <div>{part.imagedOn ? formatDateTime(part.imagedOn) : "N/A"}</div>
        </div>
        {/* ---------------------------------------------------------- */}
        {/* ---------------------------------------------------------- */}
        <div className="p-2 bg-amber-50">
          <div className="text-gray-500">Located By:</div>
          <div>{locatedBy}</div>
        </div>

        <div className="p-2 bg-amber-50">
          <div className="text-gray-500">Located On:</div>
          <div>{part.locatedOn ? formatDateTime(part.locatedOn) : "N/A"}</div>
        </div>
        {/* ---------------------------------------------------------- */}
        {/* ---------------------------------------------------------- */}
        <div className="p-2 bg-pink-50">
          <div className="text-gray-500">Picked By:</div>
          <div>{pickedBy}</div>
        </div>

        <div className="p-2 bg-pink-50">
          <div className="text-gray-500">Picked On:</div>
          <div>{part.pickedOn ? formatDateTime(part.pickedOn) : "N/A"}</div>
        </div>
        {/* ---------------------------------------------------------- */}
        {/* ---------------------------------------------------------- */}
        <div className="p-2 bg-purple-50">
          <div className="text-gray-500">Packed By:</div>
          <div>{packedBy}</div>
        </div>

        <div className="p-2 bg-purple-50">
          <div className="text-gray-500">Packed On:</div>
          <div>{part.shippedOn ? formatDateTime(part.shippedOn) : "N/A"}</div>
        </div>
      </div>
    </Modal>
  )
}